import { ProblemDescriptionPresenter } from '@/presentation/presenters/problem/problemDescriptionPresenter'
import { ProblemDescriptionViewModel } from '@/presentation/viewmodels/problem/problemDescriptionViewModel'

export function useProblemDescriptionPresenter(
  presenter: ProblemDescriptionPresenter = new ProblemDescriptionPresenter(new ProblemDescriptionViewModel())
) {
  return {
    problemDescription: presenter.problemDescription,
    isLoading: presenter.isLoading,
    error: presenter.error,
    displayedProblemHtml: presenter.displayedProblemHtml,
    getProblemDescription: presenter.getProblemDescription.bind(presenter),
    setProblemDomElement: presenter.setProblemDomElement.bind(presenter),
    updateProblemHtml: presenter.updateProblemHtml.bind(presenter)
  }
}
